import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
export default {
  "lang": "中文",
  // 菜单
  "menu": {
    "media": "媒体",//媒体
    "data": "数据",//数据
    "docking": "对接",//对接
    "Account": "账户",//账户
    "reconciliation": "对账",//对账
    "operator": "当前操作账号：",//当前操作账号
  },
  "title": {
    "appManage": "应用管理", // 应用管理
    "appList": "应用列表",// 应用列表
    "adsenseManage": "广告位管理",// 广告位管理
    "adsenseList": "广告位列表",// 广告位列表
    "blockManage": "屏蔽管理",// 屏蔽管理
    "companyInfo": "企业信息",// 企业信息
    "paymentInfo": "结算",// 结算
  },
  // 通用字段
  "common": {
    "all": "全部",//全部
    "customColumn": "自定义列",//自定义列
    "OS": "操作系统", //操作系统
    "app": "应用",//应用
    "adZone": "广告位",//广告位
    "co_mode": "合作模式", //合作模式
    "country": "国家", //国家
    "subDim": "细分维度",//细分维度
    "addApp": "添加应用",// 添加应用
    "lookApp": "查看应用",// 查看应用
    "editApp": "编辑应用",// 编辑应用
    "searchContent": "搜索内容",// 搜索内容
    "appPackage": "应用名称/包名",// 应用名称/包名
    "searchID": "搜索ID",// 搜索ID
    "searchRule": "搜索规则名", //搜索规则名
    "APPplatform": "应用平台",// 应用平台
    "selectAppPlat": "请选择应用平台",// 选择应用平台
    "enterContent": "请输入内容",// 请输入内容
    "selectTemplate": "请选择模板名称",// 请选择模板名称
    "selectApp": "请选择所属应用",// 请选择所属应用
    "selectMode": "请选择合作模式",// 请选择合作模式
    "selectFlowType": "请选择广告类型",// 请选择广告类型
    "selectArea": "请选择合作地区",// 请选择合作地区
    "select": "请选择",// 请选择
    "enter": "请填写",// 请填写
    "search": "查询",// 查询
    "addAdsense": "添加广告位",//添加广告位
    "addAdsenseBatch": "批量添加广告位",//批量添加广告位
    "lookAdsense": "查看广告位",//查看广告位
    "editAdsense": "编辑广告位",//编辑广告位
    "yuan": "元",//元
    "meiyuan": "美元",//美元
    "featureConfig": "能力配置",//能力配置
    "informationMothod": "信息流渲染方式",
    "miniProgram": "可投小程序",
    "quickApp": "可投快应用",
    "appWakeup": "可投应用唤起",
    "APKDownload": "可投下载apk",
    "engagementMaterial": "可投诱导素材",
    "appstoreUrl": "商店地址",
    "website": "Website",
    "appstoreUrl_ph": "请填写Google play或Apple App store的URL",
    "website_ph": "请填写商店关联的官网地址，例如：https://bluex.com",
    "paid": "付费",
    "free": "免费",
    "enterRuleName": "请输入规则名",//请输入搜索规则名
    "addRule": "添加规则",// 添加规则
  },
  // 复制
   "copy": {
    "copy" : "复制",  
    "copySuccess": "已成功复制到剪切板",
    "copyError": "复制失败",
    "copyTips": "请先创建APP后再试",
  },
  // 表格字段
  "table": {
    "appId": "应用id", //应用id
    "appName": "应用名称", //应用名称
    "appPackageName": "应用包名", //应用包名
    "appPlat": "应用平台", //应用平台
    "appCate": "应用类目", //应用类目
    "accessMode": "接入方式", //接入方式
    "appDaily": "应用日活", //应用日活
    "appType": "应用类型", //应用类型
    "appKeyword": "关键词", //应用关键词
    "wxAppid": "微信appId", //微信appid
    "status": "状态", //状态
    "operation": "操作", //操作
    "adsenseId": "广告位ID",//广告位ID
    "adsenseName": "广告位名称",//广告位名称
    "application": '所属应用',//所属应用
    "templateName": '模板名称',//模板名称
    "coMode": '合作模式',//合作模式
    "pdPrice": 'Flat-CPM',//Flat-CPM
    "zhpdPrice": "固定CPM",
    "coArea": '合作地区',//合作地区
    "area": '地区',//地区
    "operator": "操作人", //操作人
    "operateTime": "操作时间", //操作时间
  },
  // 操作
  "operation": {
    "edit": "编辑", //编辑
    "detail": "详情", //详情
    "adsense": "广告位", //广告位
    "delete": "删除", //删除
  },
  // 状态
  "status": {
    "approved": "已通过",//审核通过
    "checkPending": "待审核",//待审核
    "rejected": "已驳回",//审核驳回
    "open": "已开启", // 已开启
    "closed": "已关闭", //已开启
  },
  // 校验
  "required": {
    "name": "请输入名称", //请输入名称
    "packageName": "包名不能为空", //包名不能为空
    "os": "请选择应用平台", //请选择应用平台
    "cate": "请选择应用类目", //请选择应用类目
    "dau": "应用日活不能为空", //应用日活不能为空
    "desc": "应用关键词不能为空", //应用关键词不能为空
    "number": "请输入数值类型", //请输入数值类型
    "app": "请选择所属应用", //请选择所属应用
    "adName": "请输入广告位名称", //请输入广告位名称
    "template": "请选择模板", //请选择模板
    "templateSize": "请选择模板尺寸", //请选择模板尺寸
    "pdPrice": "请填写Flat-CPM", //请填写Flat-CPM
    "zhpdPrice": "请填写固定CPM", //请填写Flat-CPM
    "pdPriceLimit": "请输入0-100之间的数，最多两位小数", //pd校验
    "style": "请选择样式", //请选择样式
    "config": "请选择配置", //请选择配置
    "callbackUrl": "请填写回调URL", //请填写回调URL
    "secretKey": "请填写密钥", //请填写密钥
    "pdPriceNumber": "Flat-CPM的取值必须为数字", // Flat-CPM的取值必须为数字
    "pdPriceRange": "Flat-CPM的取值必须在 0-999.99 之间", // Flat-CPM的取值必须在 0-999.99 之间
    "pdPriceFloat": "Flat-CPM最多保留 2 位小数" // Flat-CPM最多保留 2 位小数
  },
  // 日期选择器
  "dateRangePicker": {
    "placeholder": "选择时间范围",//选择时间范围
    "to": "至",//至
    "today": "今天",//今天
    "yesterday": "昨天",//昨天
    "last7Days": "近7天",//近7天
    "last30Days": "近30天",//近30天
    "thisMonth": "本月",//本月
    "custom": "自定义",//自定义
    "compare": "对比",//对比
    "curPeriod": "本期",//本期
    "cycPeriod": "对比期",//对比期
    "prevPeriod": "上一时间段",//上一时间段
    "apply": "应用",//应用
    "compareSuffixPattern": "（对比 %s ~ %e）",//（对比 起 ~ 止）
    "tipSelectEnd": "请选择结束日期",//请选择结束日期
    "tipCompare": "点击日期移动对比区间（长度与主区间一致）",//点击日期移动对比区间
    "weekdays": "日,一,二,三,四,五,六",//星期
    "monthNames": "1 月,2 月,3 月,4 月,5 月,6 月,7 月,8 月,9 月,10 月,11 月,12 月",//月份
    "monthLabelPattern": "%y 年 %m"//2026 年 9 月
  },
  "multiSelect": {
    "all": "全部",//全部
    "search": "搜索",//搜索
    "selectAll": "全选",//全选
    "selectedCountPattern": "已选择 %n 项",//已选择 N 项
    "triggerCountPattern": "已选 %n 项",//触发器上的已选 N 项
    "clearAll": "全部清除",//全部清除
    "noneSelected": "未选择任何项",//未选择任何项
    "noMatch": "无匹配项",//无匹配项
    "apply": "应用"//应用
  },
  // 海外数据页独有的文案（statInfo 段与国内页共用，不要往里加）
  "abroadStat": {
    "bidRate": "出价率",//出价率
    "addMetric": "添加指标",//添加指标
    "addChart": "添加图表",//添加图表
    "dimSection": "维度",//汇总报表右侧面板：维度
    "metricSection": "指标",//汇总报表右侧面板：指标
    "dimDate": "日期",//汇总报表的日期维度
    "dimHour": "小时",//单日查询时日期维度显示为小时
    "metricAtLeastOne": "至少保留一个指标",//指标不可全部取消
    "dateSpanLimit": "时间跨度最多三个月，请重新选择",//查询时的时间跨度校验
    "dimTotal": "合计",//图表的对比维度：不拆维度
    "curPeriod": "本期",//图表图例：本期那条线
    "cycPeriod": "对比期",//图表图例：对比期那条线
    "legendDetail": "查看详细信息",//图表图例：展开 Top5 之外的类别
    "otherGroup": "其他",//图表图例：Top10 之外聚合出来的那条线
    "dimSortHint": "按预估收益由高到低的%s",//图表维度下拉旁的说明：按预估收益由高到低的国家
    "vsCompare": "较对比期",//较对比期
    "metricNamePattern": "%s（%p）",//卡片标题：预估收益（近7天）
    "exportFail": "导出失败"//导出失败
  },
  // 数据页面字段
  "statInfo": {
    "time": "时间",//时间
    "dimension": "维度",//维度
    "timeRange": "时间范围",//时间范围
    "to": "至",//至
    "startDate": "开始日期",//开始日期
    "endDate": "结束日期",//结束日期
    "templateName": '模板名称',//模板名称
    "trendChart": '趋势图表',//趋势图表
    "summaryReport": '汇总报表',//汇总报表
    "close": "收起", //收起
    "open": "展开", //展开
    "noData": "暂无数据", //暂无数据
    "date": "日期时间", //日期时间
    "rawReq": "原始请求",//原始请求
    "bid": "出价", //出价
    "exposure": "曝光", //曝光
    "exposureRate": "曝光率", //曝光率
    "click": "点击", //点击
    "clickRate": "点击率", //点击率
    "CPM": "CPM", //CPM
    "profit": "预估收益", //预估收益
    "export": "导出数据", //导出数据
    "os_type": "操作系统", //操作系统
    "application": "应用", //应用
    "media_ad_slot": "广告位", //广告位
    "co_mode": "合作模式", //合作模式
    "country": "国家", //国家
    "template_id": "广告类型", //广告类型
    "table": "统计表格", //统计表格
    "downloadTip": "开发者后台数据仅供参考，实际结算以对账邮件为准",//开发者后台数据仅供参考，实际结算以对账邮件为准
    "timezone": "时区", //时区
    "timeSummary": "时间汇总", //时间汇总
    "query": "查询", //查询
  },
  // 对账相关
  "reconciliation": {
    "placementMonth": "投放月份",
    "templateName": "模板名称",
    "adZone": "广告位",
    "summaryReport": "月度数据汇总报表",
    "downloadTip": "开发者后台数据仅供参考，实际结算以对账邮件为准",//开发者后台数据仅供参考，实际结算以对账邮件为准
    "generateReconciliation": "生成对账单",// 生成对账单
    "taxRate": "开票税率",//开票税率
    "monthsCheck": "投放月份不能为空",//投放月份不能为空
    "companyName": "公司主体全称",//公司主体全称
    "companyNamePlaceholder": "请输入公司主体全称",//请输入公司主体全称
    "companyNameCheck": "公司主体全称不能为空",//公司主体全称不能为空
    "batchDownloadBill": "批量下载对账单", //批量下载对账单
    "downloadBill": "下载对账单", //下载对账单
    "confirmDownloadBill": "确认生成", //确认生成
    "rawReq": "原始请求",//原始请求
    "bid": "出价", //出价
    "exposure": "曝光", //曝光
    "exposureRate": "曝光率", //曝光率
    "click": "点击", //点击
    "clickRate": "点击率", //点击率
    "CPM": "CPM", //CPM
    "profit": "预估收益", //预估收益
  },
  // sdk相关
  "sdk": {
    "interaction": "请选择广告交互", //请选择广告交互
    "deviceId": "请填写设备ID", //请填写设备ID
    "adId": "请填写广告位ID", //请填写广告位ID
    "flowType": "广告类型", //广告类型
    "createNum": "创建数量", //创建数量
    "adTemplate": "广告模板", //广告模板
    "templateSize": "模板尺寸", //模板尺寸
    "styleConfig": "样式配置", //样式配置
    "rendeMode": "渲染方式",//渲染方式
    "platformRender": "平台渲染",//平台渲染
    "selfRender": "自渲染",//自渲染
    "styleSelection": "样式选择",//样式选择
    "stylelprt": "左图右文",//左图右文
    "styleltrp": "左文右图",//左文右图
    "stylefb": "上文下图",//上文下图
    "styleab": "上图下文",//上图下文
    "elConfig": "元素配置",//元素配置
    "elImg": "图片",//图片
    "elCover": "封面",//封面
    "elVideo": "视频",//视频
    "elTitle": "标题",//标题
    "elDesc": "描述",//描述
    "elIcon": "icon", //icon
    "elProduct": "品牌名称",//品牌名称
    "elButton": "按钮文案",//按钮文案
    "videoSound": "视频声音", //视频声音
    "closeBtn": "关闭按钮", //关闭按钮
    "hidden": "隐藏", //隐藏
    "display": "显示", //显示
    "soundOff": "静音", //静音
    "soundRelease": "声音外放", //声音外放
    "videoAutoplay": "视频自动播放", //视频自动播放
    "videoNoAuto": "不自动播放", //不自动播放
    "webcast": "有网络播放", //有网络播放
    "wifiAuto": "WIFI下自动播放", //WIFI下自动播放
    "callback": "回调控制", //回调控制
    "noServer": "无需服务器判断", //无需服务器判断
    "needServer": "需要服务器判断", //需要服务器判断
    "callbackUrl": "回调URL",//回调URL
    "secretKey": "密钥",//密钥
    "newSecretKey": "生成新密钥",//生成新密钥
    "adsenseShow": "广告位展示",//广告位展示
  },
  // 对接中心
  "docking": {
    "docApi": "API对接",//api对接
    "docSdk": "SDK对接",//sdk对接
    "docSdkWord": "SDK接入文档",//sdk接入文档
    "docSdkTest": "SDK测试工具",//sdk测试工具
    "API": "API接入文档",//API接入文档
    "tipOne": "详细文档请查看",//详细文档请查看
    "tipTwo": "，如需帮助，请联系相关对接人。",//如需帮助，请联系相关对接人
    "tipThree": "接入指南",//接入指南
    "document": "文档",//文档
    "updateDate": "更新日期",//更新日期
    "version": "版本号",//版本号
    "domobAdx": "多盟ADX对接文档（多盟作为预算侧）",//多盟ADX对接文档（多盟作为预算侧）
    "templateFile": "模板文件",//模板文件
    "proto": "多盟proto文件",//多盟proto文件
    "domobSdkWord": "多盟SDK对接文档",//多盟sdk对接文档 
    "AndroidWord": "安卓接入文档",//安卓接入文档
    "IOSWord": "IOS接入文档",//IOS接入文档
    "mediaDataApi": "媒体数据API接口",//媒体数据API接口 
    "domobSdk": "多盟SDK",//多盟sdk
    "updateLog": "更新日志", //更新日志
    "sdkTipOne": "为sdk接入提供的接入前测试工具，在媒体app模拟线上真实页面渲染及广告请求，提升接入效率及体验，详见 操作指南",
    "deviceName": "设备名称", //设备名称
    "deviceID": "设备ID", //设备ID
    "deviceIDP": "请输入imei/oaid/idfa设备号",//请输入imei/oaid/idfa设备号
    "deviceType": "设备类型", //设备类型
    "testStatus": "测试状态", //测试状态
    "addDevice": "新建设备信息", //新建设备信息
    "adInteraction": "广告交互", //广告交互
    "testSaveTip": "完成新建后预计15分钟后可在测试设备上预览",//完成新建后预计15分钟后可在测试设备上预览
  },
  "message": {
    "errorComplete": "请输入完整的信息", //请输入完整的信息
    "successSava": "保存成功", //保存成功
    "successLogin": "登录成功", //登录成功
    "errorLogin": "登录失败", //登录失败
    "registLogin": "注册成功", //注册成功
    "delete": "删除成功", //删除成功
    "add": "添加成功", //添加成功
    "edit": "编辑成功", //编辑成功
    "emailRegisted": "邮箱已经注册", //邮箱已经注册
    "telRegisted": "手机号已经注册", //手机号已经注册
    "completeCompanyInfo":"你的企业信息不完整，请先完善必填项再继续操作", // 你的企业信息不完整，请先完善必填项再继续操作
    "cancel": "取消", //取消
    'confirmModify':"确认修改",//确认修改
    'confirmCompanyInfo':"确认企业信息",//确认企业信息
    "completeForm":"请完善表单必填项",//请完善表单必填项
    "mofifyPrompt": "企业信息属于敏感内容，修改后将立即生效。请确认是否继续修改。",//企业信息属于敏感内容，修改后将立即生效。请确认是否继续修改。
    "listEmpty":"暂无下载数据", //暂无下载数据
    "confirmDelete": "确认删除该条规则？", // 确认删除该条规则？
    "deleteMessage": "所有绑定的应用和广告位将会被解绑", //所有绑定的应用和广告位将会被解绑
    "noData": "暂无数据", //暂无数据
  },
  // 请求失败的 toast（utils/ajax.js 的响应拦截器用）
  "http": {
    "netError": "网络异常，请检查网络后重试",//没拿到响应
    "timeout": "请求超时，请稍后重试",//请求超时
    "failedWithCode": "请求失败（%s）",//拿到响应了，%s 是状态码
    "failed": "请求失败，请稍后重试",//连状态码都没有的兜底
  },
  "login": {
    "login": "登录", //登录
    "companyInfoLogin": "登录", //登录
    "regist": "注册", //注册
    "emailLogin": "邮箱登录", //邮箱登录
    "mobileLogin": "手机号登录", //手机号登录
    "imgCode": "图形验证码", //图形验证码
    "autoLogin": "下次自动登录", //下次自动登录
    "welcomeLogin": "欢迎登录",//欢迎登录
    "welcomeSignup": "欢迎注册",//欢迎注册
    "companyInfo": "企业信息",//欢迎注册企业信息
    "companyInfoUse": "此信息将帮助我们为您设置发布者账户",//此信息将帮助我们为您设置发布者账户
    "devPlatform": "开发者变现平台",//开发者变现平台
    "logoDevPlatform": "开发者变现平台",//logo旁开发者变现平台
    "forget": "重置密码", //重置密码
    "register": "没有账户？前往注册", //没有账户？前往注册
    "toLogin": "已有账号？返回登录", //已有账号？返回登录
    "cooperation": "合作联系：pub-support@domob.cn", //合作联系：15811494601
    "abroadCooperation": "合作联系：zhihang.cai@bluefocus.com", //合作联系：zhihang.cai@bluefocus.com
    "company": "多盟睿达科技(中国)有限公司", //多盟睿达科技(中国)有限公司
    "password": "请输入密码", //请输入密码
    "email": "邮箱/手机号", //邮箱/手机号
    "nameCheck": "用户名不能为空", //用户名不能为空
    "pwdCheck": "密码不能为空", //密码不能为空
    "confirmPwdCheck": "请再次确认密码", //请再次确认密码
    "min": "最少为6个字符", //最少为6个字符
    "codeCheck": "图片验证码不能为空", //图片验证码不能为空
    "codeCheckFalse": "验证码输入有误", //验证码输入有误
    "submit": "提交",//提交
    "setPwd": "设置密码(不能少于6个字符)",//设置密码(不能少于6个字符)
    "confirmPwd": "请确认密码",//请再次确认密码
    "pwdNotMatch": "两次输入的密码不一致", //两次输入的密码不一致
    "enterprise": "企业账号",//企业账号
    "personal": "个人账号",//个人账号
    "phoneError": "手机号输入有误", //手机号输入有误
    "emailCheck": "请输入邮箱", //请输入邮箱
    "emailError": "邮箱格式异常", //邮箱格式异常
    "pwdAgain": "请再次输入密码", //请再次输入密码
    "pwdDiff": "两次输入密码不一致", //两次输入密码不一致
    "loginIng": "登录中", //登录中
    "msg1": "短信验证码已发送至您手机，请注意查收！",//短信验证码已发送至您手机，请注意查收！
    "msg2": "为了保证您的账号安全，请完成邮箱验证后登录。",//为了保证您的账号安全，请完成邮箱验证后登录。
    "msg3": "发送邮件",//发送邮件
    "msg4": "邮箱验证成功！",//邮箱验证成功！
    "msg5": "邮箱验证失败！",//邮箱验证失败！
    "msg6": "链接已经无效，可能是以下原因：",//链接已经无效，可能是以下原因：
    "msg7": "链接已经过期；",//链接已经过期；
    "msg8": "链接有可能已经使用过；",//链接有可能已经使用过；
    "msg9": "您修改了帐户的邮箱。",//您修改了帐户的邮箱。
    "msg10": "邮箱验证码已发送至您邮箱，请注意查收！",//邮箱验证码已发送至您邮箱...
  },
  "forget": {
    "title": "多盟开发者后台", //多盟开发者后台
    "type": "找回密码方式", //找回密码方式
    "valid": "账号验证", //账号验证
    "resetPwd": "重设密码", //重设密码
    "phone": "手机找回", //手机找回
    "email": "邮箱找回", //邮箱找回
    "tel": "手机号", //手机号
    "Email": "邮箱", //邮箱
    "msgCode": "短信验证码", //短信验证码
    "emailCode": "邮箱验证码", //邮箱验证码
    "toEmail": "使用邮箱找回", //使用邮箱找回
    "toPhone": "使用手机找回", //使用手机找回
    "showEinfoMsg": "我们刚给你发了一封电子邮件，请注意查收！", //我们刚给你发了一封电子邮件，请注意查收！
    "next": "下一步", //下一步
    "getCode": "获取验证码", //获取验证码
    "sendEmail": "发送验证邮箱", //发送验证邮箱
    "getEmail": "获取验证邮箱", //获取验证邮箱
    "codeError": "验证码输入有误", //验证码输入有误
    "phoneCheck": "手机号不能为空", //手机号不能为空
    "smsCheck": "验证码不能为空", //短信验证码不能为空
    "verifyCheck": "验证码不能为空", //验证码不能为空
    "newPwd": "请输入新密码", //请输入新密码
    "renewPwd": "请再次输入新密码", //请再次输入新密码
    "confirm": "确认修改", //确认修改
    "resetSuccess": "密码重置成功", //密码重置成功
    "congratulate": "恭喜您，已经成功设置新的密码", //恭喜您，已经成功设置新的密码
    "loginNow": "立即登录", //立即登录
    "resetError": "密码重置失败！", //密码重置失败！
    "beover": "链接已经无效，或页面已经过期", //链接已经无效，或页面已经过期
    "resetPass": "再次申请重置密码", //再次申请重置密码
    "reInputPsd": "密码不一致，请重新输入", //密码不一致，请重新输入
    // 以下为登录前「忘记密码」流程新增
    "entry": "忘记密码？", //登录页入口文字链
    "pageTitle": "找回密码", //页面标题
    "pageDesc": "请输入注册时使用的邮箱或手机号，我们会先核验该账号是否存在", //页面说明
    "stepVerify": "验证身份", //步骤1
    "stepNewPwd": "设置新密码", //步骤2
    "stepDone": "完成", //步骤3
    "verifyByEmail": "邮箱验证", //邮箱验证
    "verifyByPhone": "手机号验证", //手机号验证
    "telPlaceholder": "请输入注册手机号", //找回密码页手机号输入框占位文案
    "emailFormat": "邮箱格式不正确", //邮箱格式不正确
    "phoneRequired": "请输入手机号", //请输入手机号
    "phoneFormat": "手机号格式不正确", //手机号格式不正确
    "notRegisteredEmail": "该邮箱未注册，请确认后重试，或", //该邮箱未注册...
    "notRegisteredPhone": "该手机号未注册，请确认后重试，或", //该手机号未注册...
    "goSignup": "前往注册", //前往注册
    "backToLogin": "返回登录", //返回登录
    "prevStep": "上一步", //上一步
    "resetTitle": "重置密码", //重置密码
    "captchaWrong": "请填写正确的图形验证码", //请填写正确的图形验证码
    "confirmPwdPh": "再次输入密码(不能少于6个字符)", //再次输入密码...
    "resetDoneDesc": "为保障账号安全，该账号在其他设备的登录状态已全部退出。\n请使用新密码重新登录。", //重置成功说明，\n 处强制断行
    "autoRedirect": "（%s 秒后自动跳转）", //（%s 秒后自动跳转）
    "resend": "重新获取", //重新获取
    "resendPattern": "重新获取 %ss", //重新获取 XXs
  },
  "companyInfo": {
    "companyName": "企业法定名称", //企业法定名称
    "brandNameEN": "企业英文简称", //企业英文简称
    "brandNameCN": "企业中文简称", //企业中文简称
    "country": "国家/地区", // 国家/地区
    "industry": "行业分类", //行业分类
    "websiteURL": "官网",//官网
    "companyNameCheck": "企业法定名称不能为空",
    "companyNameStartEndCheck": "企业名称不能数字开头或结尾",
    "companyNameCNCharCheck": "企业名称不能包含非法字符",
    "companyNameLengthCheck": "企业名称长度需在2-120字符之间",
    "companyNameSpecialCharCheck": "企业名称不允许包含特殊字符或Emoji",
    "brandNameENCheck": "企业英文简称不能为空", // 企业英文简称
    "countryCheck": "国家/地区不能为空", //国家/地区不能为空
    "industryCheck": "行业分类不能为空", //行业分类不能为空
    "companyNameFormatCheck": '只能输入中文或英文，不可包含特殊字符',//只能输入中文或英文，不可包含特殊字符
    "brandNameENFormatCheck": '只能包含英文字符',//只能包含英文字符
    "brandNameENUniqueCheck": '不能与企业名称完全一致',//不能与企业名称完全一致
    "brandNameCNFormatCheck": '不可包含特殊字符',//不可包含特殊字符
    "brandNameCNChineseCheck": '必须包含中文字符',//必须包含中文字符
    "websiteFormatCheck": '请输入正确的 URL 格式',//请输入正确的 URL 格式
    "companyInfo": "企业信息", //企业信息
    "companyNamePlaceholder": "请填入注册的公司名称", //请填入注册的公司名称
    "prompt": "必须和你注册的企业名称匹配", // 必须和你注册的企业名称匹配
    "urlExplame": "https://example.com",//websiteURL的例子
    "edit": "编辑", //编辑
    "save": "保存", //保存
    "cancel": "取消", //取消
    "reset": "重置", //重置
  },
  "block": {
    "blockContent": "屏蔽内容", //屏蔽内容
    "effectScope": "生效范围", //生效范围
    "ruleName": "规则名称", //规则名称
    "blockApp": "屏蔽应用", //屏蔽应用
    "blockDomain": "屏蔽域名", //屏蔽域名
    "blockCategory": "屏蔽类别", //屏蔽类别
    "blockKeyword": "屏蔽关键词",//屏蔽关键词
    "effectScope": "生效范围", //生效范围
    "app": "应用", //应用
    "domain": "域名", //域名
    "category": "类别", //类别
    "keyword": "关键词",//关键词
  },
  "dialog": {
    "addRule": "新建", //新建屏蔽规则
    "editRule": "编辑", //编辑屏蔽规则
    "enterApp": "请输入包名，包名之间以换行符分隔",//请输入包名，包名之间以换行符分隔
    "enterDomain": "请输入域名，域名之间以换行符分隔", //请输入域名，域名之间以换行符分隔
    "enterCategory": "请选择类别", //请选择类别
    "enterKeyword": "请输入关键词，关键词之间以换行符分隔", //请输入关键词，关键词之间以换行符分隔
    "enterRuleName": "请输入规则名",//请输入搜索规则名  
    "selectEffectScope": "请选择生效范围", //请选择生效范围
    "appInvaildMessage": "个无效的应用包名已忽略", //个无效的应用包名已忽略
    "appRepeatMessage": "个重复的应用包名已忽略", //个重复的应用包名已忽略
    "domainInvaildMessage": "个无效的域名已忽略", //个无效的域名已忽略
    "domainRepeatMessage": "个重复的域名已忽略", //个重复的域名已忽略
    "confirmLeave": "确定离开", //确定离开
    "message": "如果离开，您填写的内容将不会被保存", //如果离开，您填写的内容将不会被保存
    "yes": "是", //是
    "no": "否", //否
  },
  // 子账号管理
  "subAccount": {
    "tabRole": "角色",
    "tabAccount": "账号",
    "menu": {
      "sdkDoc": "SDK接入文档",
      "sdkTest": "SDK测试工具",
      "appAdsTxt": "App-Ads.txt",
      "settleView": "结算明细（仅查看）",
      "settleOperate": "结算明细（可操作）",
      "bankInfo": "银行信息",
      "subAccount": "子账号管理",
    },
    "picker": {
      "selectedCount": "已选择 {n} 项",
      "clearAll": "全部清除",
      "selectAll": "全选",
      "searchMenu": "搜索菜单…",
      "searchApp": "搜索应用名称 / 包名",
      "noMenuSelected": "未授权任何菜单",
      "noAppSelected": "未选择任何应用",
      "noMatch": "无匹配项",
    },
    "role": {
      "name": "角色",
      "namePh": "请输入角色名",
      "roleName": "角色名称",
      "nameFieldPh": "请输入角色名称",
      "menuPerm": "菜单权限",
      "appPerm": "应用权限",
      "accountCount": "账号数",
      "createdAt": "创建时间",
      "updatedAt": "更新时间",
      "create": "创建角色",
      "edit": "编辑角色",
      "allApps": "全部应用",
      "allMenus": "全部菜单",
      "someApps": "指定应用",
      "someAppsCount": "指定 {n} 个应用",
      "more": "等 {total} 项",
      "menuPermCount": "菜单权限（{n} 项）",
      "appPermCount": "已授权应用（{n} 个）",
      "selectAppPerm": "请选择应用权限",
      "created": "角色已创建",
      "saved": "角色已保存",
      "deleted": "角色已删除",
      "deleteTitle": "删除角色？",
      "deleteBody": "将删除角色{name}。该角色下没有账号，删除不影响任何登录账号",
      "deleteBlocked": "该角色下还有{n}个账号，请先转移到其他角色，或删除这些账号后再删角色",
      "jumpedToAccounts": "已切到「账号」，并按角色「{name}」筛选",
      "confirmDelete": "确认删除",
      "errNameEmpty": "请输入角色名称",
      "errNameLength": "角色名称不超过20个字符",
      "errNameExists": "角色名已存在",
      "errAppEmpty": "应用权限为「指定」时，请至少选择一个应用",
      "errMenuEmpty": "请至少授权一个菜单",
    },
    "account": {
      "email": "登录邮箱",
      "name": "账号名称",
      "role": "角色",
      "keyword": "邮箱 / 账号名称",
      "keywordPh": "请输入关键词",
      "rolePh": "请选择角色",
      "statusPh": "请选择状态",
      "enabled": "启用",
      "disabled": "停用",
      "add": "添加账号",
      "edit": "编辑账号",
      "mainTag": "主账号",
      "allPerm": "全部权限",
      "namePh": "请输入账号名称",
      "emailPh": "请输入登录邮箱",
      "rolePh": "请选择账号所属角色",
      "createTitle": "确认创建账号？",
      "createBody1": "初始密码将发送至{email}，请确认邮箱无误。",
      "createBody2": "邮件内含登录地址、登录邮箱、系统生成的初始密码，如果忘记密码，可在登录页「忘记密码」自行重置。",
      "createConfirm": "确认创建",
      "created": "账号已创建，初始密码已发送至 {email}",
      "saved": "保存成功",
      "statusOn": "账号{email} 已启用",
      "statusOff": "账号{email} 已停用，停用后无法登录",
      "deleteTitle": "删除账号？",
      "deleteBody": "将删除账号 {name}（{email}），该邮箱立即无法登录。",
      "deleted": "账号已删除",
      "errEmailEmpty": "请输入登录邮箱",
      "errEmailFormat": "邮箱格式不正确",
      "errEmailExists": "该邮箱已被使用",
      "errNameEmpty": "请输入账号名称",
      "errRoleEmpty": "请选择账号所属角色",
    },
  },
  "save": "保存", // 保存
  "confirm": "确认",
  "cancel": "取消", // 取消
  "logout": "退出登录",//退出登录
  ...zhLocale
}